export default __webpack_public_path__ + "static/media/Dance.78a7d502.mp4";